// 消息提示工具类
let messageInstance = null

// 创建消息提示容器
function createMessageContainer() {
  if (messageInstance) return messageInstance
  
  const container = document.createElement('div')
  container.className = 'message-container'
  container.style.cssText = `
    position: fixed;
    top: 20px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 9999;
    pointer-events: none;
  `
  document.body.appendChild(container)
  messageInstance = container
  return container
}

// 显示消息提示
function showMessage(message, type = 'info', duration = 3000) {
  const container = createMessageContainer()
  
  const messageEl = document.createElement('div')
  messageEl.className = `message-item message-${type}`
  
  const icons = {
    success: '✓',
    error: '✕',
    warning: '⚠',
    info: 'ℹ'
  }
  
  // 使用浅色主题，符合项目风格
  const colors = {
    success: '#10b981',
    error: '#ef4444',
    warning: '#f59e0b',
    info: '#3b82f6'
  }
  
  messageEl.style.cssText = `
    background: #ffffff;
    border: 1px solid ${colors[type]};
    border-left: 4px solid ${colors[type]};
    color: #374151;
    padding: 14px 20px;
    border-radius: 8px;
    margin-bottom: 10px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    display: flex;
    align-items: center;
    gap: 12px;
    min-width: 200px;
    max-width: 400px;
    pointer-events: auto;
    animation: messageFadeIn 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  `
  
  messageEl.innerHTML = `
    <span style="color: ${colors[type]}; font-weight: bold; font-size: 18px; line-height: 1;">${icons[type]}</span>
    <span style="flex: 1; font-size: 14px; line-height: 1.5;">${message}</span>
  `
  
  container.appendChild(messageEl)
  
  // 自动移除
  setTimeout(() => {
    messageEl.style.animation = 'messageFadeOut 0.3s cubic-bezier(0.4, 0, 0.2, 1)'
    setTimeout(() => {
      if (messageEl.parentNode) {
        messageEl.parentNode.removeChild(messageEl)
      }
    }, 300)
  }, duration)
  
  return messageEl
}

// 添加动画样式
if (!document.getElementById('message-styles')) {
  const style = document.createElement('style')
  style.id = 'message-styles'
  style.textContent = `
    @keyframes messageFadeIn {
      from {
        opacity: 0;
        transform: translateY(-20px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }
    
    @keyframes messageFadeOut {
      from {
        opacity: 1;
        transform: translateY(0);
      }
      to {
        opacity: 0;
        transform: translateY(-20px);
      }
    }
  `
  document.head.appendChild(style)
}

// 导出方法
export default {
  success: (message, duration) => showMessage(message, 'success', duration),
  error: (message, duration) => showMessage(message, 'error', duration),
  warning: (message, duration) => showMessage(message, 'warning', duration),
  info: (message, duration) => showMessage(message, 'info', duration)
}

